import {IPrimaryKey} from "../interfaces/iprimary-key";

export class MedicoPrimaryKey implements IPrimaryKey<MedicoModel> {
  tipo_Conselho: number = 0;
  sigla_UF: string = '';
  num_Conselho: string = '';

  get id(): string {
    return `tipoConselho/${this.tipo_Conselho}/uf/${this.sigla_UF}/numConselho/${this.num_Conselho}`;
  }
}

export class MedicoModel extends MedicoPrimaryKey {
  cod_Profissao: string | undefined;
  nome: string = '';
  nome_Reduzido?: string;
  cnpj_Cpf?: string;
  ind_QOS?: boolean;
  endereco?: string;
  bairro?: string;
  telefone1?: string;
  telefone2?: string;
  cep?: string;
  cod_Municipio?: number;
  sigla_UF_Endereco?: string;
  data_Contrato?: Date;
  status?: string;
  tipo_Profissional?: string;
  seq_Rua?: number;
  identidade?: string;
  sexo?: string;
  seq_Escolaridade?: number;
  data_Colacao_Grau?: Date;
  entidade_Colacao_Grau?: string;
  telefone_Favor?: string;
  pessoa_favor?: string;
  validade_Contrato_Dias?: number;
  data_Nascimento?: Date;
  numero?: string;
  complemento?: string;
  foto?: string;
  altura?: string;
  peso?: string;
  seq_Estab?: number;
  assinatura_Digital?: Uint8Array;
  seq_Tratamento?: number;
  seq_Estab_Repasse_Honor?: number;
  descricao_Conselho: string = '';
  descricao_Especialidade: string = '';
}

